import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import selectors from '../../store/selectors';

import AddMassOffering from './AddMassOffering';

const enhance = connect(state => ({
  selectedMass: selectors.getSelectedMass(state),
}));

const AddMassOfferingContainer = ({ selectedMass }) =>
  !!selectedMass && <AddMassOffering selectedMass={selectedMass} />;

AddMassOfferingContainer.propTypes = {
  selectedMass: PropTypes.object,
};

export default enhance(AddMassOfferingContainer);
